import { create } from 'zustand'

const initialState = {
  currentStep: 0,
  templates: [],

  // dados de cadastro
  sexo: '',
  nomeCompletoDefesa: '',
  cpfDefesa: '',
  telefoneContato: '',
  enderecoCompletos: '',
  cep: '',
  numero: '',
  complemento: '',

  // dados da multa
  placa: '',
  dataInfracao: null,
  formattedDataInfracao: '',
  horaInfracao: null,
  formatedHoraInfracao: '',
  autoInfracao: '',
  autoRenainf: '',
  templateId: '',
  enquadramento: '',
  local: '',
  orgaoEmissor: '',

  // dados da defesa
  fase: '',
};

export const useCadastroMultaNaoAcompanhadaStore = create((set, get) => ({
  ...initialState,

  reset: () => set(initialState),

  setStep: (step) => set({ currentStep: step }),

  resetDadosBasicos: () => {
    const {
      sexo,
      nomeCompletoDefesa,
      cpfDefesa,
      telefoneContato,
      enderecoCompletos,
      cep,
      numero,
      complemento,
    } = initialState;

    set({
      sexo,
      nomeCompletoDefesa,
      cpfDefesa,
      telefoneContato,
      enderecoCompletos,
      cep,
      numero,
      complemento,
    });
  },

  goToNext: () => set((state) => ({ currentStep: state.currentStep + 1 })),
  goToPrevious: () => set((state) => {
    if (state.currentStep > 0) {
      return {
        currentStep: state.currentStep - 1.
      };
    }

    // não mudar nada
    return state;
  }),

  setTemplates: (templates) => set({ templates }),

  setDadosBasicos: ({
    sexo,
    nomeCompletoDefesa,
    cpfDefesa,
    telefoneContato,
    enderecoCompletos,
    cep,
    numero,
    complemento
  }) => {
    set({
      sexo,
      nomeCompletoDefesa,
      cpfDefesa,
      telefoneContato,
      enderecoCompletos,
      cep,
      numero: numero || "",
      complemento: complemento || "",
    });
  },

  setDadosMulta: ({
    placa,
    dataInfracao,
    formattedDataInfracao,
    horaInfracao,
    formatedHoraInfracao,
    autoInfracao,
    autoRenainf,
    templateId,
    enquadramento,
    local,
    orgaoEmissor,
  }) => {
    set({
      placa,
      dataInfracao,
      formattedDataInfracao,
      horaInfracao,
      formatedHoraInfracao,
      autoInfracao,
      autoRenainf,
      templateId,
      enquadramento,
      local,
      orgaoEmissor
    })
  },

  setDadosDefesa: ({ fase }) => {
    set({ fase });
  },

  getAllFormValues: () => ({
    // dados de cadastro
    Sexo: get().sexo,
    NomeCompletoDefesa: get().nomeCompletoDefesa,
    CpfDefesa: get().cpfDefesa,
    TelefoneContato: get().telefoneContato,
    EnderecoCompletos: get().enderecoCompletos,

    // dados da multa
    Placa: get().placa,
    DataInfracao: get().dataInfracao,
    formattedDataInfracao: get().formattedDataInfracao,
    HoraInfracao: get().horaInfracao,
    formatedHoraInfracao: get().formatedHoraInfracao,
    AutoInfracao: get().autoInfracao,
    AutoRenainf: get().autoRenainf,
    TemplateId: get().templateId,
    Enquadramento: get().enquadramento,
    Local: get().local,
    OrgaoEmissor: get().orgaoEmissor,

    // dados da defesa
    Fase: get().fase,
  })
}));